import React from 'react';
import {
    Tag,
    Row,
    Space,
    Button,
    Input,
    DatePicker,
    Select,
    Table,
    Pagination,
    Checkbox,
    Modal,
    Upload,
    Transfer,
    Form,
    Col,
    Rate,
    Divider,
    Radio,
    message,
    Popconfirm,
    Alert
} from 'antd';
import { Redirect, Link, withRouter } from 'react-router-dom';
import store from "../store/store.js";
import { DeleteOutlined, UploadOutlined, EditOutlined, PlusOutlined } from '@ant-design/icons'
import moment from 'moment';

const { Option, OptGroup } = Select;
const { TextArea } = Input;
const { RangePicker } = DatePicker;

class Edit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            condition: {
                id: props.id,
            },
            visible: false,
            loading: false,
            loading2: false,
        };
        store.subscribe(() => {
            // console.log('state状态改变了，新状态如下')
            // console.log(store.getState().data.isLogin)
        })
    }

    componentDidMount() {


    }

    sub() {
        let that = this
        that.setState({
            loading: true
        })
        let arr = that.state.condition
        arr.dwtype = 1
        fetch('/Pay/dojiaofei', {
            method: "POST",
            body: JSON.stringify(arr)
        })
            .then(res => res.json())
            .then(data => {
                if (data.status == 1) {
                    message.success(data.msg);
                    this.props.refresh()
                    this.mdchange()
                } else {
                    message.error(data.msg)
                    that.setState({
                        loading: false
                    })
                }
            })
    }

    mdchange() {
        let that = this
        let visible = !that.state.visible
        that.setState({
            visible
        })
        if (visible) {
            fetch('/Pay/jiaofei', {
                method: "POST",
                body: JSON.stringify({
                    id: this.props.id,
                })
            })
                .then(res => res.json())
                .then(data => {
                    that.setState({
                        condition: data.data,
                        edit_react: data.edit_react ? data.edit_react : [],
                        room: data.room ? data.room : [],
                    })
                })
        } else {
            that.setState({
                condition: {},
                loading: false
            })
        }
    }

    arrradio(arr) {
        if (arr) {
            return arr.map((item, index) => <Radio value={item.id} key={index}>{item.name}</Radio>)
        }
    }
    arrCheckbox(arr) {
        if (arr) {
            return arr.map((item, index) =>
                <Checkbox value={item.id} key={index}>{item.name || item.number}</Checkbox>
            )
        }
    }

    onChange(name, e) {
        let that = this
        let value = e.target.value
        console.log(name, value)
        let data = Object.assign({}, this.state.condition, { [name]: value })
        this.setState({
            condition: data
        })
    }
    onSelChange(name, value) {
        let that = this
        console.log(name, value)
        let data = Object.assign({}, this.state.condition, { [name]: value })
        this.setState({
            condition: data
        })
    }


    render() {

        return (
            <>
                <a href='javascript:void(0)' onClick={this.mdchange.bind(this)}>缴费</a>

                <Modal title="编辑" maskClosable={false} destroyOnClose={true} width={450} visible={this.state.visible}
                    onCancel={this.mdchange.bind(this)} footer={null}>
                    <Form
                        layout="vertical"
                        // labelCol={{ span: 3 }}
                        wrapperCol={{ span: 24 }}
                        autoComplete="off"
                    >
                        <Row gutter={[20, 0]} justify="start">
                            {this.state.condition.tips ?
                                <Col className="gutter-row" span={24}>
                                    <Form.Item>
                                        <div dangerouslySetInnerHTML={{ __html: this.state.condition.tips }}></div>
                                    </Form.Item>
                                </Col>
                                : null}
                            <Col className="gutter-row" span={24}>
                                <Form.Item
                                    label="状态"
                                >
                                    <Radio.Group onChange={this.onChange.bind(this, 'edit')}
                                        value={this.state.condition.edit ? this.state.condition.edit : 0}>
                                        {this.arrradio(this.state.edit_react)}
                                    </Radio.Group>
                                </Form.Item>
                            </Col>
                            {this.state.condition.edit == 2 &&
                                <>
                                    <Col className="gutter-row" span={24}>
                                        <Form.Item
                                            label="金额"
                                        // required={true}
                                        >
                                            <Input placeholder="请输入"
                                                value={this.state.condition.true_num ? this.state.condition.true_num : null}
                                                onChange={this.onChange.bind(this, 'true_num')}
                                                suffix={'元'}
                                            />
                                        </Form.Item>
                                    </Col>
                                    {this.props.type == 5 ? <>
                                        <Col className="gutter-row" span={24}>
                                            <Form.Item
                                                label="房间"
                                            // required={true}
                                            >
                                                <Checkbox.Group
                                                    value={this.state.condition.jfroom ? this.state.condition.jfroom : []}
                                                    onChange={this.onSelChange.bind(this, 'jfroom')}>
                                                    <Space wrap>
                                                        {this.arrCheckbox(this.state.room)}
                                                    </Space>
                                                </Checkbox.Group>
                                            </Form.Item>
                                        </Col>
                                    </> : null}
                                </>
                            }
                            <Col className="gutter-row" span={24}>
                                <Form.Item>
                                    <Row justify={"center"}>
                                        <Button type='primary' onClick={this.sub.bind(this)}
                                            loading={this.state.loading}>提交</Button>
                                    </Row>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </Modal>
            </>
        )
    }
}

export default Edit
